.quiz {
  margin-top: var(--section-spacing);
  margin-left: auto;
  margin-right: auto;
  max-width: 480px;

  .quiz__progress,
  .quiz__question,
  .quiz__result {
    text-align: center;
    font-weight: normal;
  }

  .quiz__progress {
    color: var(--color-text-alternate);
  }

  .quiz__answers {
    margin-top: var(--section-spacing-small);
    margin-bottom: var(--section-spacing-small);
  }

  .quiz__answer {
    display: block;
    border: 1px solid var(--color-border);
    border-top-width: 0;
    cursor: pointer;
    padding: .75rem .75rem .75rem 2.5rem;
    position: relative;

    input {
      position: absolute;
      left: .75rem;
      top: .9rem;
    }

    svg {
      height: 1rem;
      position: absolute;
      left: .9rem;
      top: 1rem;
      color: var(--color-text-alternate);
    }

    &:first-child {
      border-top-width: 1px;
      border-top-left-radius: var(--border-radius-lg);
      border-top-right-radius: var(--border-radius-lg);
    }

    &:last-child {
      border-bottom-left-radius: var(--border-radius-lg);
      border-bottom-right-radius: var(--border-radius-lg);
    }

    &--answered-correctly {
      background: rgba(var(--color-success), 0.1);

      svg {
        color: var(--color-success);
      }
    }

    &--answered-incorrectly {
      background: rgba(var(--color-error), 0.2);

      svg {
        color: var(--color-error);
      }
    }
  }

  .quiz__begin_action {
    text-align: center;
  }

  .quiz__action {
    text-align: right;
  }

  .quiz__actions-top {
    min-height: 60px;
  }

  .quiz__timer {
    float: left;
    padding-top: 12px;
    span:first-child {
      font-weight: bold;
    }
  }

  .complete--quiz {
    float: right;
    cursor: pointer;
  }

  .quiz__result-options {
    margin-top: calc(var(--section-spacing-small) - 1rem);
    text-align: center;

    .btn {
      margin-top: 1rem;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }

  .quiz__time-limit-message {
    text-align: center;
  }
}

/* Hide stuff in the mobile app */
// This stuff is superceded by the new way we handle styles on the mobile app in themes/mobile_app/index.scss. We can't remove this yet though to support clients who have not migrated yet. I think removing this after a few months from now should be okay (i.e remove the mobile app stuff here on March 2023)
[data-quiz-for-mobile-app] {
  header, footer, .course-lesson-course-header, .course-navigation-toggle, .course-author, .course-lesson__title, .course-lesson__updated, .course-flow, #simplero-ticket-launcher, .simplero-admin-bar, .quiz__next-lesson, .floating-shopping-cart-button-container, #course-nav-container, .simplero-landing-page-container.simplero-collapsed, .cc-bottom {
    display: none !important;
  }
  #course-lesson-container {
    width: 100% !important;
  }
}
